<template>
  <div class="activation-info">
    <img class="banner" :src="$IMG_BASE_URL + '/final/1_6.png'" />
    <div class="info">
      <div class="item">
        <div class="key">
          <img class="icon" :src="$IMG_BASE_URL + '/1_21.png'" />
          <span>车&ensp;架&ensp;号 ：</span>
        </div>
        <div class="value">{{ $store.state.encodeInfo.frameNumber }}</div>
      </div>
      <div class="item">
        <div class="key">
          <img class="icon" :src="$IMG_BASE_URL + '/1_11.png'" />
          <span>产品类别 ：</span>
        </div>
        <div class="value">{{ $store.state.encodeInfo.categoryName }}</div>
      </div>
      <div class="item">
        <div class="key">
          <img class="icon" :src="$IMG_BASE_URL + '/1_13.png'" />
          <span>购买日期 ：</span>
        </div>
        <div class="value">{{ $store.state.encodeInfo.buyDateStr }}</div>
      </div>
      <div class="item">
        <div class="key">
          <img class="icon" :src="$IMG_BASE_URL + '/1_35.png'" />
          <span>企业名称 ：</span>
        </div>
        <div class="value" v-if="$store.state.encodeInfo.zhangtao === '车质汇'">深圳市车质汇汽车配件有限公司</div>
        <div class="value" v-else-if="$store.state.encodeInfo.zhangtao === '硬速'">硬速科技（深圳）有限公司</div>
        <div class="value" v-else>{{ $store.state.encodeInfo.zhangtao }}</div>
      </div>
    </div>

    <div class="buttons" v-if="isShowBack">
      <my-button class="activation-btn" @click.native="activation" :loading="isOncheck">激活</my-button>
      <my-button class="back-btn" @click.native="$router.back()">返回</my-button>
    </div>
    <div class="buttons" v-else>
      <my-button class="activation-btn" @click.native="antiFake" :loading="isOncheck">防伪验证</my-button>
    </div>
  </div>
</template>

<script>
import { reqCheck } from '@/network'
import { Toast } from 'vant'

export default {
  data() {
    return {
      isShowBack: window.sessionStorage.getItem('firstActivation'),
      isOncheck: false
    }
  },
  created() {
    this.activationInfo = this.$route.query
  },
  methods: {
    activation() {
      Toast('激活成功')
      this.isShowBack = false
    },
    async antiFake() {
      if (this.isOncheck) return
      this.isOncheck = true
      try {
        const {
          data: { modifyDateTimeStr, securityNum }
        } = await reqCheck(this.$store.state.encode)
        this.$router.push({
          path: '/anti-fake-result',
          query: {
            lastTime: modifyDateTimeStr,
            num: securityNum
          }
        })
      } catch {
        this.$router.push('/anti-fake-result?isError=true')
      }
      this.isOncheck = false
    }
  }
}
</script>

<style scoped lang="less">
.activation-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;

  .banner {
    width: 230px;
    height: 78px;
  }

  .info {
    width: 300px;

    .item {
      display: flex;
      padding: 0 10px;
      line-height: 40px;

      .key {
        font-weight: bold;

        .icon {
          margin-right: 10px;
          width: 15px;
          height: 15px;
          transform: translateY(-2px);
        }
      }

      .value {
        flex: 1;
        font-size: 12px;
        color: #999;
        .over-hidden-text();
      }

      &:nth-child(2n) {
        background-color: #f5f5f5;
      }
    }
  }

  .buttons {
    display: flex;
    flex-direction: column;
    align-items: center;
    .activation-btn {
      margin-bottom: 20px;
    }
  }
}
</style>
